import { Action, createReducer, on } from '@ngrx/store';
import { LeadsStore } from '../models/store/leads/leadsStore';

import { loadVleLeads, paginateLeads, removeAllVleLeads, removeVleLeads } from 'src/actions/leads/leads.action';

export const initialState: LeadsStore = {
  fetching: false,
  data: {
    vleLeads: [],
    totalDocuments: {
      vle: 0
    },
  }
};

const leadsReducer = createReducer(initialState,
  on(loadVleLeads, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        vleLeads: [
          ...state.data.vleLeads,
          ...payload.filter(p => !state.data.vleLeads.find(ds => ds._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          vle: totalDocuments
        },
      }
    })
  ),
  on(removeVleLeads, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        vleLeads: state.data.vleLeads
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          vle: state.data.totalDocuments.vle - 1
        },
      }
    })
  ),
  on(removeAllVleLeads, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        vleLeads: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          vle: 0
        },
      }
    })
  ),
  on(paginateLeads, (state) => state)
);

export function reducer(state: LeadsStore, action: Action): any {
  return leadsReducer(state, action);
}
